import _ from 'lodash';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import { Checkbox, StyledSelect } from '.';
import SearchInput from './SearchInput';
import { TeamMembersFilter } from '../components/TeamMembersFilter/TeamMembersFilter';
import { TeamMembersSharedFilesFilter } from './TeamMembersSharedFilesFilter';
import { useSelector } from 'react-redux';
import { selectTeamMembersFilterOpen } from '../redux/slicers/uiSlicer';
import { useState } from 'react';

export default function ActionFilters({
  className,
  sortProps,
  filterProps,
  selectedProps,
  showTeamMemberFilter,
  teamMemberFilterIconOnly = false,
  membersFilterDefaultSelected,
  searchBar,
  showSharedFilter,
  filterSelected,
  userFilter,
  loading,
  teamFilterModal = null
}) {
  const isMembersFilterOpen = useSelector(selectTeamMembersFilterOpen);
  const [isSharedMembersFilterOpen, setSharedMembersFilterShow] = useState(false);
  const filterByValue = filterProps?.data?.find(item => `${item.value}` === `${filterProps?.value?.value}`)
  const sortByValue = sortProps?.data?.find(item => `${item.value}` === `${sortProps?.value?.value}`)

  const styledSelectInput = (value) => {
    return (
      <StyledSelect
        value={value}
        onChange={filterProps.onChange}
        options={filterProps.data}
        isSearchable={!filterProps?.disabledSearchable}
        placeholder={filterProps?.placeholder || 'Filter by'}
        disabled={loading}
      />
    );
  }
  return (
    <div
      className={cx(
        'filter_container',
        className,
        (isMembersFilterOpen || isSharedMembersFilterOpen) && !teamFilterModal ? 'memberSidebarOpen' : ''
      )}>
      <div className="fc-left d-flex">
        {((filterProps && filterProps.data && filterProps.data.length > 0) || filterSelected) && (
          <div className={cx('minWidth165', filterProps.containerClass)}>
            {!filterByValue && styledSelectInput(null)}
            {filterByValue && styledSelectInput(filterByValue)}
          </div>
        )}
        {sortProps && sortProps.data && sortProps.data.length > 0 && (
          <div className={cx('minWidth165', sortProps.containerClass)}>
            <StyledSelect
              value={sortByValue}
              onChange={sortProps.onChange}
              options={sortProps.data}
              placeholder={'Sort by'}
              disabled={loading || sortProps?.disabled}
              isSearchable={!sortProps?.disabledSearchable}
            />
          </div>
        )}
        {userFilter && (
          <div className="filter layout">
            <Button
              className={cx(userFilter?.selected === 'is_internal' ? 'active' : '', 'btn-table')}
              onClick={() => userFilter?.setSelected('is_internal')}
              variant={userFilter?.selected === 'is_internal' ? 'primary' : ''}>
              Internal users
            </Button>

            {/* External users is commented because this is not developed yet. */}
            {/* <Button
              className={cx(userFilter?.selected === 'is_external' ? 'active' : '', 'btn-grid')}
              onClick={() => userFilter?.setSelected('is_external')}
              variant={userFilter?.selected === 'is_external' ? 'primary' : ''}>
              External users
            </Button> */}
          </div>
        )}
      </div>
      <div className="fc-right d-flex gap-3 align-items-center">
        {searchBar && (
          <SearchInput value={searchBar.value} placeholder="Search" onChange={searchBar.onChange} disabled={loading} />
        )}
        {selectedProps && (
          <div className="d-flex gap-1">
            <Checkbox
              selected={selectedProps.allSelected}
              onChange={() => selectedProps.onSelectAll(!selectedProps.allSelected)}
              className="selectAll"
              label="Select All"
            />

            {selectedProps.selectedList?.length > 0 && (
              <span className="text-muted">( {selectedProps.selectedList.length} )</span>
            )}
          </div>
        )}
        {(showTeamMemberFilter || teamFilterModal) && <TeamMembersFilter teamFilterModal={teamFilterModal} disabled={loading} iconOnly={teamMemberFilterIconOnly} defaultSelected={membersFilterDefaultSelected} />}
        {showSharedFilter && (
          <TeamMembersSharedFilesFilter
            setSharedMembersFilterShow={(flag) => setSharedMembersFilterShow(flag)}
            hideOptionList={teamFilterModal}
            teamFilterModal={teamFilterModal}
          />
        )}
      </div>
    </div>
  );
}
